var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecentralization({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 104,
    viewBox: "0 0 105 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_2541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3562 51.9997C96.3562 76.2235 76.7238 95.8558 52.5001 95.8558C28.2763 95.8558 8.64392 76.2235 8.64392 51.9997C8.64392 27.7759 28.2763 8.14355 52.5001 8.14355C76.7238 8.14355 96.3562 27.7858 96.3562 51.9997Z",
    fill: "#EBFFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 104C23.8332 104 0.5 80.6767 0.5 52C0.5 23.3233 23.8332 0 52.5 0C81.1668 0 104.5 23.3332 104.5 52C104.5 80.6668 81.1767 104 52.5 104ZM52.5 1.66242C24.7436 1.66242 2.16242 24.2436 2.16242 52C2.16242 79.7564 24.7436 102.338 52.5 102.338C80.2564 102.338 102.838 79.7564 102.838 52C102.838 24.2436 80.2564 1.66242 52.5 1.66242Z",
    fill: "#EBFFF2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_270_2541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.7743 63.2725L78.1054 63.3541L77.7743 63.4357C75.8156 63.9162 74.2891 65.4303 73.8018 67.3524L73.719 67.6788L73.6362 67.3524C73.1489 65.4212 71.6132 63.9162 69.6637 63.4357L69.3326 63.3541L69.6637 63.2725C71.6224 62.7919 73.1489 61.2778 73.6362 59.3557L73.719 59.0293L73.8018 59.3557C74.2891 61.2869 75.8248 62.7919 77.7743 63.2725Z",
    fill: "#046C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8955 23.6055L59.2541 23.6962L58.8955 23.7869C56.7713 24.3127 55.1161 25.9447 54.5827 28.0391L54.4908 28.3927L54.3988 28.0391C53.8654 25.9447 52.2102 24.3127 50.0952 23.7869L49.7366 23.6962L50.0952 23.6055C52.2194 23.0797 53.8746 21.4477 54.3988 19.3624L54.4908 19.0088L54.5827 19.3624C55.1161 21.4477 56.7713 23.0888 58.8955 23.6055Z",
    fill: "#F7CA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6004 67.5694L35.0878 67.6873L34.6004 67.8052C31.7497 68.5124 29.5152 70.7065 28.8071 73.5171L28.6876 73.9976L28.568 73.5171C27.8508 70.7065 25.6254 68.5033 22.7747 67.8052L22.2874 67.6873L22.7747 67.5694C25.6254 66.8622 27.86 64.6681 28.568 61.8575L28.6876 61.377L28.8071 61.8575C29.5244 64.6681 31.7497 66.8713 34.6004 67.5694Z",
    fill: "#04E38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6046 57.9593L88 58.059L87.6046 58.1587C85.2781 58.7299 83.4574 60.5251 82.878 62.819L82.7769 63.2088L82.6757 62.819C82.0964 60.5251 80.2756 58.7299 77.9491 58.1587L77.5537 58.059L77.9491 57.9593C80.2756 57.3881 82.0964 55.5929 82.6757 53.299L82.7769 52.9092L82.878 53.299C83.4574 55.5929 85.2781 57.3881 87.6046 57.9593Z",
    fill: "#046C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1987 47.3154H63.7784L57.4886 58.0593L51.1987 68.8032L44.9088 58.0593L38.6097 47.3154H51.1987Z",
    stroke: "#046C50",
    strokeWidth: 2.06,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4151 76.2106L50.8768 66.3008",
    stroke: "#046C50",
    strokeWidth: 2.06,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4151 80.0006C63.538 80.0006 65.2589 78.3038 65.2589 76.2107C65.2589 74.1177 63.538 72.4209 61.4151 72.4209C59.2922 72.4209 57.5713 74.1177 57.5713 76.2107C57.5713 78.3038 59.2922 80.0006 61.4151 80.0006Z",
    fill: "#F7CA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9823 76.2106L51.5206 66.3008",
    stroke: "#046C50",
    strokeWidth: 2.06,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9822 80.0006C43.1051 80.0006 44.826 78.3038 44.826 76.2107C44.826 74.1177 43.1051 72.4209 40.9822 72.4209C38.8594 72.4209 37.1384 74.1177 37.1384 76.2107C37.1384 78.3038 38.8594 80.0006 40.9822 80.0006Z",
    fill: "#F7CA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.307 66.3005C58.307 70.1719 55.1253 73.3089 51.1987 73.3089C47.2722 73.3089 44.0905 70.1719 44.0905 66.3005C44.0905 62.429 47.2722 59.292 51.1987 59.292C55.1253 59.292 58.307 62.429 58.307 66.3005Z",
    fill: "#03E287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2903 33.4072L38.9501 47.7687",
    stroke: "#046C50",
    strokeWidth: 2.06,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0122 30.7324C40.5133 29.2546 38.0764 29.2546 36.5775 30.7324C35.0786 32.2103 35.0786 34.6129 36.5775 36.0908C38.0764 37.5686 40.5133 37.5686 42.0122 36.0908C43.5111 34.6129 43.5111 32.2103 42.0122 30.7324Z",
    fill: "#F7CA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8438 47.66L39.4098 47.3154",
    stroke: "#046C50",
    strokeWidth: 2.06,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1219 50.3339C20.623 48.8561 20.623 46.4534 22.1219 44.9756C23.6208 43.4977 26.0576 43.4977 27.5565 44.9756C29.0554 46.4534 29.0554 48.8561 27.5565 50.3339C26.0576 51.8118 23.6208 51.8118 22.1219 50.3339Z",
    fill: "#F7CA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2008 42.5917C41.4237 39.8536 36.927 39.8536 34.1498 42.5917C31.3727 45.3298 31.3727 49.7633 34.1498 52.5014C36.927 55.2396 41.4237 55.2396 44.2008 52.5014C46.9779 49.7633 46.9779 45.3298 44.2008 42.5917Z",
    fill: "#03E287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1072 33.4072L63.4474 47.7687",
    stroke: "#046C50",
    strokeWidth: 2.06,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3853 30.7324C61.8842 29.2546 64.3211 29.2546 65.82 30.7324C67.3189 32.2103 67.3189 34.6129 65.82 36.0908C64.3211 37.5686 61.8842 37.5686 60.3853 36.0908C58.8864 34.6129 58.8864 32.2103 60.3853 30.7324Z",
    fill: "#F7CA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5536 47.66L62.9968 47.3154",
    stroke: "#046C50",
    strokeWidth: 2.06,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2755 50.3339C81.7744 48.8561 81.7744 46.4534 80.2755 44.9756C78.7766 43.4977 76.3398 43.4977 74.8409 44.9756C73.3419 46.4534 73.3419 48.8561 74.8409 50.3339C76.3398 51.8118 78.7766 51.8118 80.2755 50.3339Z",
    fill: "#F7CA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1966 42.5917C60.9737 39.8536 65.4704 39.8536 68.2475 42.5917C71.0246 45.3298 71.0246 49.7633 68.2475 52.5014C65.4704 55.2396 60.9737 55.2396 58.1966 52.5014C55.4195 49.7633 55.4195 45.3298 58.1966 42.5917Z",
    fill: "#03E287"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_2541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_270_2541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 61,
    fill: "white",
    transform: "translate(21 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecentralization);
export default __webpack_public_path__ + "static/media/decentralization.86e177cc306ec511e554e3b89e314d03.svg";
export { ForwardRef as ReactComponent };